// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__wS7Kn","withTitle":"Logo_withTitle__dQjbz","popup":"Logo_popup__nqkUv","menu":"Logo_menu___8aDm","fadeIn":"Logo_fadeIn__V8dKy","spin":"Logo_spin__DCTor"};